import moment from "moment";
import Api from "lib/api";
export const API_PATH = "/api/v1/attendance";

export const getAttendance = async (from, to) => {
  return Api.get(`${API_PATH}/attendance/date`, {
    from: from,
    to: to,
  });
};
export const saveAttendance = async (attendanceList) => {
  return Api.post(`${API_PATH}/save-attendance`, attendanceList);
};
export const deleteAttendance = async (attendanceList) => {
  return Api.post(`${API_PATH}/delete-attendance`, attendanceList);
};

export const ATTENDANCE_TYPE = [
  { type: "F", text: "Ferie", color: "#2766a4" },
  { type: "P", text: "Permessi", color: "#edc960" },
  { type: "M", text: "Malattia", color: "#64c578" },
  { type: "D", text: "Donazione sangue", color: "#e22323" },
  { type: "S", text: "Permessi per studio", color: "#9e62be" },
  { type: "MA", text: "Maternità", color: "#e18dec" },
];

export const getHolidays = (year) => {
  const holidays = [
    `${year}-01-01`,
    `${year}-01-06`,
    `${year}-04-25`,
    `${year}-05-01`,
    `${year}-06-02`,
    `${year}-08-15`,
    `${year}-10-04`,
    `${year}-11-01`,
    `${year}-12-08`,
    `${year}-12-25`,
    `${year}-12-26`,
  ];

  // Calcolo Pasqua
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  const easter = moment([year, month - 1, day]);
  const easterMonday = easter.clone().add(1, "day");

  holidays.push(easter.format("YYYY-MM-DD"));
  holidays.push(easterMonday.format("YYYY-MM-DD"));

  return holidays;
};

export const getMonthlyWorkingSeconds = (timeRange) => {
  const start = timeRange.from.clone().startOf("month");
  const year = timeRange.from.year();
  const daysInMonth = start.daysInMonth();
  let workingDays = 0;

  const holidays = getHolidays(year);

  for (let i = 0; i < daysInMonth; i++) {
    const currentDay = start.clone().add(i, "days");
    const dayOfWeek = currentDay.day();
    const dateString = currentDay.format("MM-DD");

    // Escludi Sabato (6), Domenica (0) e Festività
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isHoliday = holidays.includes(dateString);

    if (!isWeekend && !isHoliday) {
      workingDays++;
    }
  }

  // 8 ore al giorno * 3600 secondi
  return workingDays * 8 * 3600;
};
